import {EventsApi, EventDetailApi, EnrollmentActionsApi, StudentGradesApi, EVAUApi, GraceExamConvocationsApi} from '../../src/_api/exams/src'
import {asyncLazySingleton} from "../_common/common";

export const eventsApi = new asyncLazySingleton(async () => new EventsApi())
export const eventDetailApi = new asyncLazySingleton(async () => new EventDetailApi())
export const enrollmentApi = new asyncLazySingleton(async () => new EnrollmentActionsApi())
export const studentGradesApi = new asyncLazySingleton(async () => new StudentGradesApi())
export const evauApi = new asyncLazySingleton(async () => new EVAUApi())
export const graceConvocationApi = new asyncLazySingleton(async () => new GraceExamConvocationsApi())